/**
 * Client-side session ID management.
 * Generates a UUID, rotates after 30 minutes of inactivity.
 */

const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

let sessionId: string | null = null;
let lastActivityAt = 0;

function generateId(): string {
  return crypto.randomUUID();
}

/** Get the current session ID. Rotates if >30min since last call. */
export function getSessionId(): string {
  const now = Date.now();
  if (!sessionId || now - lastActivityAt > SESSION_TIMEOUT_MS) {
    sessionId = generateId();
  }
  lastActivityAt = now;
  return sessionId;
}
